import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChildren,
  input,
  output,
  signal,
  TemplateRef,
} from '@angular/core';
import { TabComponent } from '../tab/tab.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'ui-tabs',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzButtonModule, NzTabsModule, NgTemplateOutlet],
  template: `
    <nz-tabset
      [nzTabBarExtraContent]="extraTemplate()!"
      [nzSelectedIndex]="selectedIndex()"
      [nzTabBarStyle]="tabsStyles"
      (nzSelectedIndexChange)="onTabChange($event)"
    >
      @for (tab of tabs(); track tab.title()) {
        <nz-tab [nzTitle]="tab.title()" [nzDisabled]="tab.disabled()">
          <ng-container *ngTemplateOutlet="tab.content()"></ng-container>
        </nz-tab>
      }
    </nz-tabset>
  `,
})
export class TabsComponent {
  private readonly tabComponents = contentChildren(TabComponent);
  public readonly tabsStyles: Record<string, string> | null = {
    'border-bottom': '1px solid #D9D9D9',
    margin: '0px 10px 16px 10px',
  };

  selectedIndex = input<number>(0);
  activeTabIndex = signal<number>(0);
  activeTabIndexChange = output<number>();

  tabs = computed(() =>
    this.tabComponents().map((tab) => ({
      title: tab.title,
      content: tab.contentTemplate,
      disabled: tab.disabled,
    })),
  );

  extraTemplate = input<TemplateRef<any> | null>(null);

  onTabChange(index: number): void {
    this.activeTabIndex.set(index);
    this.activeTabIndexChange.emit(index);
  }
}
